module.exports = __webpack_public_path__ + "img/test_image.01d18838.png";